import React from 'react';
import PropTypes from 'prop-types';
import VisibilitySensor from 'react-visibility-sensor';


const TutorialModSection = ({content}) => {
    
    return (
        <VisibilitySensor
            partialVisibility
            offset={{top:300}}
            minTopValue={100}
            scrollCheck
            scrollDelay={10} >
            {({isVisible}) => 
                <div className={isVisible ? "tutorial-mod-section active" : "tutorial-mod-section"} dangerouslySetInnerHTML={{__html: content}} />
            }
        </VisibilitySensor>
        
    )
}

TutorialModSection.propTypes = {
    content: PropTypes.string
}

export default TutorialModSection
